import {YandexAdsContextProvider} from '@shared/Ads/Yandex/context/YandexAdsContext';
import {useEnvConfig} from '@web-catalog/env';
import {PropsWithChildren} from 'react';

import {useGetCurrentAppPackageName} from '@web-catalog/hooks';

import {useGetVkId} from '@web-catalog/store/auth';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics';

type Props = PropsWithChildren<{}>;

export const YandexAdsContextProviderWrapper = ({children}: Props) => {
  const {STATS_URL} = useEnvConfig();
  const getActiveAppPackageName = useGetCurrentAppPackageName();
  const getUserVkId = useGetVkId();
  return (
    <YandexAdsContextProvider
      statsUrl={STATS_URL}
      getActiveAppPackageName={getActiveAppPackageName}
      getUserVkId={getUserVkId}
      logTmrEvent={logTmrEvent}
      emitYmEvent={emitYmEvent}
    >
      {children}
    </YandexAdsContextProvider>
  );
};
